import React from "react";
import { makeStyles } from "@material-ui/core";
import Page from "src/components/Page";
import ProfileDetails from "../../user/ProfileDetails";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const Account = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Account">
      <ProfileDetails />
    </Page>
  );
};

export default Account;
